import React from 'react';
import './dropdown-menu-burger.scss';

const DropDownMenuHamburger = ({ onClick, active, cssClass, notify }) => (
    <button
        aria-label="Menu"
        aria-controls="navigation"
        className={`hamburger hamburger--squeeze ${active ? 'is-active' : ''} ${
            cssClass ? cssClass : ''
        }`}
        onClick={onClick}
        type="button">
        {notify > 0 ? (
            <span className="site-dropdown__notification d-md-none">
                {notify}
            </span>
        ) : null}
        <span className="hamburger-box" aria-hidden="true">
            <span className="hamburger-inner" />
        </span>
        <small
            className={`font-weight-bold slim-header__link-text p-0 ${
                active ? 'd-none' : 'd-none d-lg-block'
            }`}>
            MENY
        </small>
    </button>
);

export default DropDownMenuHamburger;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/site-header/dropdown-menu-burger.jsx